import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import Layout from '../Layout';

const Success = withTranslation()(({ email = '', firstName = '', lastName = '', t }) => {
  const fullName = `${firstName} ${lastName}`.trim();

  return (
    <div className="wrapper ula success">
      <Layout cover={{ src: '/images/cover-main.png' }}>
        <div className="wrapper-shrink">
          <img src="/images/ULA/Success.svg" alt="success" />
          <div className="title">
            <strong>{t('Sign in complete.')}</strong>
          </div>

          {email && (
            <div className="signed-in-as">
              {t('You are now signed in as')} <strong>{fullName}</strong> ({email})
            </div>
          )}

          <div className="description">{t('You can now start using all Chaos products licensed to you')}</div>
          <div>
            <strong>{t('You may now close this window.')}</strong>
          </div>
        </div>
      </Layout>
    </div>
  );
});

export default connect((state) => ({
  email: state.app.email,
  firstName: state.app.firstName,
  lastName: state.app.lastName,
}))(Success);
